import { 
  vitaminsProducts, 
  sportsProducts, 
  immunityProducts, 
  brainProducts, 
  weightProducts, 
  heartProducts, 
  digestiveProducts 
} from '../../../mocks/supplements';

interface ProductSectionProps {
  title: string;
  category: string;
}

export default function ProductSection({ title, category }: ProductSectionProps) {
  const getProducts = () => {
    switch (category) {
      case 'vitamins':
        return vitaminsProducts;
      case 'sports':
        return sportsProducts;
      case 'immunity':
        return immunityProducts;
      case 'brain':
        return brainProducts;
      case 'weight':
        return weightProducts;
      case 'heart':
        return heartProducts;
      case 'digestive':
        return digestiveProducts;
      default:
        return vitaminsProducts;
    }
  };

  const products = getProducts();

  return (
    <section className="py-16 bg-white" data-product-shop>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900">{title}</h2>
          <button className="text-emerald-600 hover:text-emerald-700 font-medium transition-colors cursor-pointer whitespace-nowrap">
            View All →
          </button>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {products.map((product) => (
            <div 
              key={product.id}
              className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden cursor-pointer"
            >
              <div className="aspect-square overflow-hidden bg-gray-50">
                <img 
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              
              <div className="p-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-2 group-hover:text-emerald-600 transition-colors">
                  {product.name}
                </h3>
                
                <div className="flex items-center mb-3">
                  <div className="flex text-yellow-400">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className={`ri-star-${i < Math.floor(product.rating) ? 'fill' : 'line'} text-sm`}></i>
                    ))}
                  </div>
                  <span className="text-sm text-gray-500 ml-2">
                    {product.rating} ({product.reviews})
                  </span>
                </div>
                
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-2">
                    <span className="text-2xl font-bold text-gray-900">
                      ${product.price}
                    </span>
                    {product.originalPrice && (
                      <span className="text-lg text-gray-400 line-through">
                        ${product.originalPrice}
                      </span>
                    )}
                  </div>
                  <button className="bg-emerald-600 text-white px-4 py-2 rounded-full hover:bg-emerald-700 transition-colors duration-200 whitespace-nowrap">
                    Add to Cart
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
